//
//
//
//
//
//
//
//
//
//
//

import { version } from '../../package.json';

export default {
  name: 'ViuLabel',
  data: () => ({
    version
  })
};
